var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',_vm._l((_vm.phoneNumbers),function(ref){
var phoneNumber = ref.phoneNumber;
var id = ref.id;
var remove = ref.remove;
var accept = ref.accept;
return _c('v-list-item',{key:id},[_c('v-list-item-content',[_vm._v(_vm._s(phoneNumber))]),(accept)?_c('v-list-item-action',[_c('v-btn',{attrs:{"color":"primary","icon":""},on:{"click":accept}},[_c('v-icon',[_vm._v(_vm._s(_vm.mdiCheck))])],1)],1):_vm._e(),_c('v-list-item-action',[_c('v-btn',{attrs:{"icon":""},on:{"click":remove}},[_c('v-icon',[_vm._v(_vm._s(accept ? _vm.mdiClose : _vm.mdiDelete))])],1)],1)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }